import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/(site)/discover/hosting/page.tsx");
